module.exports = __webpack_public_path__ + "img/e_r_logo_white.05c18273.png";